import { useEffect } from 'react';

/**
 * Bandeau "DEV" — s'affiche UNIQUEMENT sur l'environnement de développement
 * (serveur Hermes / Tailscale :8455). Jamais en prod (app.bandzontour.com).
 * Détection par hostname/port, pas de variable (partagé dev/prod).
 */
export default function DevBanner() {
  useEffect(() => {
    const host = (window.location.hostname || '').toLowerCase() + ':' + window.location.port;
    // Allowlist STRICTE (égalité exacte host:port), jamais par sous-chaîne —
    // un hostname prod ne peut pas fuité le bandeau DEV.
    const DEV_HOSTS = [
      'chopiou-server.tail4389d7.ts.net:8456',
      'chopiou-server.tail4389d7.ts.net:8455',
      'localhost:8456', 'localhost:8455',
      '127.0.0.1:8456', '127.0.0.1:8455'
    ];
    const isDev = DEV_HOSTS.indexOf(host) !== -1;
    if (!isDev) return;

    const banner = document.createElement('div');
    banner.id = 'dev-banner';
    banner.setAttribute('role', 'banner');
    banner.textContent = 'DEV — environnement de test (données fictives)';
    banner.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:9999',
      'background:linear-gradient(90deg,#e67e22,#f39c12)',
      'color:#1a1a1a', 'font-family:Inter,system-ui,sans-serif',
      'font-size:12px', 'font-weight:700', 'letter-spacing:.06em',
      'text-transform:uppercase', 'text-align:center', 'padding:4px 12px',
      'box-shadow:0 2px 8px rgba(0,0,0,.4)'
    ].join(';');
    document.body.appendChild(banner);

    // Favicon DEV distinct : RETIRER d'abord tous les <link rel~=icon> statiques
    // (index.html pointe favicon-pass.png) sinon le favicon prod gagne / reste en cache.
    document.querySelectorAll("link[rel~='icon']").forEach((l) => l.parentNode?.removeChild(l));
    const icon = document.createElement('link');
    icon.rel = 'icon';
    icon.type = 'image/png';
    icon.href = '/favicon-dev.png?v=20261010d';
    document.head.appendChild(icon);
  }, []);

  return null;
}
